import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import Common from '../../utilities/common';
import { PieChart } from '@mui/x-charts/PieChart';
import Gradient from "javascript-color-gradient";
import { BarChart } from '@mui/x-charts/BarChart';
import { LineChart } from '@mui/x-charts/LineChart';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';

export interface IComunidadAutonomaProvinciasFieldProps {
    comunidadAutonoma: string;
    field: string;
    title: string;
    label: string;
    color: string;
}

export interface IComunidadAutonomaProvinciasFieldState {
    data: any[];
    totalMen: number;
    totalWoman: number;
    sexData: any[];
}

export default class ComunidadAutonomaProvinciasField extends React.Component<IComunidadAutonomaProvinciasFieldProps, IComunidadAutonomaProvinciasFieldState> {
    public constructor(props: IComunidadAutonomaProvinciasFieldProps) {
        super(props);

        this.state = {
            data: [],
            totalMen: 0,
            totalWoman: 0,
            sexData: []
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IComunidadAutonomaProvinciasFieldProps>, nextContext: any): void {
        this.Get(nextProps.comunidadAutonoma, nextProps.field);
        this.GetTotalFieldMen(nextProps.comunidadAutonoma, nextProps.field);
        this.GetTotalFieldWomen(nextProps.comunidadAutonoma, nextProps.field);
        this.GetTotalFieldMenData(nextProps.comunidadAutonoma, nextProps.field);
    }

    componentDidMount(): void {
        this.Get(this.props.comunidadAutonoma, this.props.field);
        this.GetTotalFieldMen(this.props.comunidadAutonoma, this.props.field);
        this.GetTotalFieldWomen(this.props.comunidadAutonoma, this.props.field);
        this.GetTotalFieldMenData(this.props.comunidadAutonoma, this.props.field);
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            {
                                this.props.title
                            }
                        </Typography>
                        <Stack direction={'row'}>
                            <ManIcon style={{fontSize: '16px', color: Common.MAN_BORDER_COLOR}}/>
                            <Typography variant="body2">
                                {
                                    this.state.totalMen
                                }
                            </Typography>
                            <WomanIcon style={{fontSize: '16px', color: Common.WOMAN_BORDER_COLOR}}/>
                            <Typography variant="body2">
                                {
                                    this.state.totalWoman
                                }
                            </Typography>
                        </Stack>
                    </Box>
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <PieChart
                                series={[
                                    {
                                        data: this.state.data,
                                        innerRadius: 45,
                                        outerRadius: 90,
                                        paddingAngle: 0,
                                        highlightScope: { faded: 'global', highlighted: 'item' },
                                        faded: { innerRadius: 45, additionalRadius: -30, color: 'gray' }
                                    }
                                ]}
                                margin={{
                                    left: 50,
                                    right: 50,
                                    bottom: 100,
                                    top: 50
                                }}
                                height={350}
                                slotProps={
                                    {
                                        legend: {
                                            direction: 'row',
                                            position: {
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            },
                                            itemMarkWidth: 20,
                                            itemMarkHeight: 6,
                                            markGap: 5,
                                            itemGap: 10,
                                            labelStyle: {
                                                fontSize: 11
                                            }
                                        }
                                    }
                                }
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <LineChart
                                dataset={this.state.sexData}
                                xAxis={[{ scaleType: 'point', dataKey: 'provincia' }]}
                                series={[
                                    { dataKey: 'hombres', label: 'Hombres', color: Common.MAN_BORDER_COLOR },
                                    { dataKey: 'mujeres', label: 'Mujeres', color: Common.WOMAN_BORDER_COLOR}
                                ]}
                                height={350}
                                margin={{
                                    bottom: 100
                                }}
                                slotProps={
                                    {
                                        legend: {
                                            direction: 'row',
                                            position: {
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            },
                                            itemMarkWidth: 20,
                                            itemMarkHeight: 6,
                                            markGap: 5,
                                            itemGap: 10,
                                            labelStyle: {
                                                fontSize: 11
                                            }
                                        }
                                    }
                                }
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        )
    }

    private Get(comunidadAutonoma: string, field: string) {
        let url = `${Common.END_POINT}/charts/provincia/total/comunidadautonoma/${comunidadAutonoma}/field/${field}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const length = response.length;
            const data: any[] = [];

            if(length > 0) {
                let startColor = '#ffe000';
                let endColor = '#ff9900';

                const palletteMap = Common.FIELD_PALETTE_MAP;

                const fieldColors = palletteMap.find((fieldColor: any) => {
                    return fieldColor.field.toLowerCase() == field.toLowerCase();
                });

                if(fieldColors != null) {
                    startColor = fieldColors.colors[0];
                    endColor = fieldColors.colors[1]
                }

                const gradientArray = new Gradient()
                .setColorGradient(startColor, endColor)
                .setMidpoint(length > 1 ? length : 2)
                .getColors();

                for(let i = 0; i < response.length; i++) {
                    const dataItem: any = {};
                    dataItem.id = i;
                    dataItem.label = response[i].provincia;
                    dataItem.value = response[i].total;
                    dataItem.color = gradientArray[i];

                    data.push(dataItem);
                }
            }

            this.setState(
                {
                    data: data
                }
            );
        })
    }

    private GetTotalFieldMen(comunidadAutonoma: string, field: string) {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/${comunidadAutonoma}/provincias/total/sexo/h/fields/${field}/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    totalMen: response[0].total
                }
            );
        })
    }

    private GetTotalFieldWomen(comunidadAutonoma: string, field: string) {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/${comunidadAutonoma}/provincias/total/sexo/m/fields/${field}/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    totalWoman: response[0].total
                }
            );
        })
    }

    private GetTotalFieldMenData(comunidadAutonoma: string, field: string) {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/${comunidadAutonoma}/provincias/total/sexo/h/fields/${field}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.provincia = response[i].provincia;
                dataItem.hombres = response[i].total;
                dataItem.mujeres = 0;

                data.push(dataItem);
            }

            this.GetTotalFieldWomenData(comunidadAutonoma, field, data);
        })
    }

    private GetTotalFieldWomenData(comunidadAutonoma: string, field: string, sourceData: any[]) {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/${comunidadAutonoma}/provincias/total/sexo/m/fields/${field}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = JSON.parse(JSON.stringify(sourceData));

            for(let i = 0; i < response.length; i++) {
                let dataItem: any = data.find((value: any) => {
                    return value.provincia == response[i].provincia;
                });

                if (dataItem == null) {
                    dataItem = {};
                    dataItem.provincia = response[i].provincia;
                    dataItem.hombres = 0;

                    data.push(dataItem);
                }

                dataItem.mujeres = response[i].total;
            }

            data.sort((a, b) => {
                if(a.provincia < b.provincia) { return -1; }
                if(a.provincia > b.provincia) { return 1; }
                return 0;
            });
            
            this.setState({
                sexData: data
            })
        })
    }
}